<template>
  <div class="public-view-header">
    <div class="public-view-header__container">
      <!-- Logo/Brand -->
      <div class="public-view-header__brand">
        <img src="/img/logos/new-logo.jpeg" alt="CRESiteIQ" class="public-view-header__logo" />
      </div>

      <!-- Right Side: User Email and Theme Toggle -->
      <div class="public-view-header__right">
        <!-- User Email -->
        <div class="public-view-header__user">
          <div class="public-view-header__user-icon">
            <svg 
              class="public-view-header__user-icon-svg"
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              <path 
                d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              />
              <circle 
                cx="12" 
                cy="7" 
                r="4" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span class="public-view-header__email">{{ email }}</span>
        </div>

        <!-- Theme Toggle -->
        <div class="public-view-header__theme-toggle">
          <theme-toggle />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicViewHeader',

  props: {
    email: {
      type: String,
      required: true
    }
  }
};
</script>
